export type HomeCardLayout =
  | 'quick_icons'
  | 'quick_emergency'
  | 'quick_professional'
  | 'vehicle_carousel'
  | 'topic_cards';

export const BUILTIN_HOME_QUICK_SECTION_IDS = new Set([
  'legal',
  'emergency',
  'financial',
  'vehicle',
  'professionals',
]);

export function isTopicCardLayout(layout: HomeCardLayout | undefined): boolean {
  return !layout || layout === 'topic_cards';
}

export function resolveItemCardLayout(
  itemLayout: HomeCardLayout | undefined,
  sectionLayout: HomeCardLayout | undefined
): HomeCardLayout {
  return itemLayout ?? sectionLayout ?? 'topic_cards';
}
